import { create } from 'zustand';

import { createStateSlice } from './slices/state.slice';
import { createQueueMutationsSlice } from './slices/queue-mutations.slice';
import { createControlsSlice } from './slices/controls.slice';
import { createSelectorsSlice } from './slices/selectors.slice';
import type { JobQueueStore, QueueAggregate } from './slices/types';

// Re-export types for consumers
export type { JobQueueStore, QueueAggregate };
export type {
  Job,
  RenderJob,
  AlbumJob,
  UpscaleJob,
  ControlJob,
} from './job-queue.types';
export { isRenderJob, isAlbumJob, isUpscaleJob } from './job-queue.types';

export const useJobQueueStore = create<JobQueueStore>()((...a) => ({
  ...createStateSlice(...a),
  ...createQueueMutationsSlice(...a),
  ...createControlsSlice(...a),
  ...createSelectorsSlice(...a),
}));
